import TypeFraisInsertForm from "../../components/TypeFrais/TypeFraisInsertForm";




function TypeFraisAdd(){


    return (
        <TypeFraisInsertForm   ></TypeFraisInsertForm>
    );
}
export default TypeFraisAdd;